// AUTO-GENERATED by scripts/inject-build-hash.js — DO NOT EDIT BY HAND.
// Regenerated on every `yarn start` and `yarn build` via the prestart/prebuild hooks.

export const BUILD_HASH = "unknown";
export const BUILD_HASH_FULL = "unknown";
export const BUILD_TIME = "2026-07-07T22:01:13.856Z";
